import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App.tsx';
import * as serviceWorkerRegistration from './serviceWorkerRegistration.ts';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// Register service worker
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/OneSignalSDKWorker.js')
      .then(registration => {
        //console.log('ServiceWorker registration successful');
      })
      .catch(err => {
        //console.log(' ServiceWorker registration failed: ', err);
      });
  });
}

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register({
  onUpdate: registration => {
    // عدم تحديث الصفحة تلقائياً عند تحديث Service Worker
    // console.log('New service worker available, but page will not auto-refresh');
    // التعليق على الكود التالي لمنع التحديث التلقائي
    /*
    const waitingServiceWorker = registration.waiting;
    if (waitingServiceWorker) {
      waitingServiceWorker.addEventListener("statechange", event => {
        if ((event.target as ServiceWorker).state === "activated") {
          window.location.reload();
        }
      });
      waitingServiceWorker.postMessage({ type: "SKIP_WAITING" });
    }
    */
  }
});
